import React from 'react';

import { Flex, Typography } from 'components';
import styled from 'styled-components';

interface CourseEvolutionProps {
  percentage: number;
}

const EvolutionBar = styled.div`
  background: ${({ theme }) => theme.colors.primary_400};
  height: 4px;
`;

const CourseEvolution = ({ percentage }: CourseEvolutionProps) => {
  return (
    <Flex flexDirection="column">
      <Typography type="type0" fontWeight="bold" color="primary_400" px={3} mb={1}>
        {percentage}%
      </Typography>
      <EvolutionBar style={{ maxWidth: `${percentage}%` }} />
    </Flex>
  );
};

export default CourseEvolution;
